import React from "react";

import { Link } from "react-router-dom";

function Services() {
  return (
    <>
      <section className="services" id="services">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12">
              <div className="title text-center">
                <h2>Our Services</h2>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 color-bg text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-copy-outline"></i>
                </div>
                <h3>Custom ERP</h3>
                <b>
                  Do you know 50% of standard ERP software projects fail for the
                  first time!
                </b>
                <p>
                  At Macrozion tech systems, we design and customize enterprise
                  resource planning (ERP)systems for all types of businesses.
                  our experts can integrate third party
                </p>
                <Link to="/Erp" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-alarm-outline"></i>
                </div>
                <h3>SAP</h3>
                <b>
                  Do you know 77% of world's transaction revenue occues through
                  SAP!
                </b>
                <p>
                  SAP implementation enables the creation of an efficient work
                  environment by integrating various work
                </p>
                <Link to="/Sap" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 color-bg text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-book-outline"></i>
                </div>
                <h3>IT Support services</h3>
                <p>
                  <b>
                    THE COST OF CYBERSECURITY CRIMES WILL BE 6 TRILLION DOLLARS
                    BY THE END OF 2021.
                  </b>
                </p>
                <p>
                  Macrozion Techsystem offers a broad range of IT infrastructure
                  support services to assure the high
                </p>

                <Link to="/Itsupport" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4  text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-briefcase-outline"></i>
                </div>
                <h3>Payment Gateway</h3>
                <p>
                  <b>
                    In India, 53 Billion Digital Transactions Were Recorded in
                    2021!
                  </b>
                </p>
                <p>
                  A secure and convenient payment gateway has emerged as a
                  necessity for most e-retailers, as it helps them boost their
                  customer loyalty and profits.
                </p>
                <Link to="/Payment" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 color-bg text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-crop"></i>
                </div>
                <h3>Barcode Software Implementation</h3>
                <p>
                  Barcodes are important to improve your business productivity,
                  speed, and accuracy. Barcode systems will help you track your
                  inventory, identify weak: areas of the supply chain, and
                  streamline your business tracks.
                </p>
                <Link to="/Barcode" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-home-outline"></i>
                </div>
                <h3>Tally Solutions</h3>
                <p>
                  <b>
                    Do you know Tally ERP 9 is one of the most popular
                    accounting and monetary application software used in India
                    and worldwide!
                  </b>
                </p>
                <p>
                  Tally implementation and installation requires high technical
                  expertise and careful execution.
                </p>
                <Link to="/Tally" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
